export default [
    {
        field: 'max_apv_monthly_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Mensual',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'max_apv_yearly_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Anual',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required', 'isNotNegative' ],
    },
]
